/** Inline loading spinner. Previously re-declared locally in eight pages. */
import React from "react";

const SIZES = {
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-10 h-10",
} as const;

interface SpinnerProps {
  size?: keyof typeof SIZES;
  label?: string;
  className?: string;
}

export default function Spinner({ size = "md", label, className = "" }: SpinnerProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} role="status">
      <svg
        className={`${SIZES[size]} animate-spin text-accent`}
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
          className="opacity-90"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
      {label ? <span className="text-sm text-content-muted">{label}</span> : null}
      <span className="sr-only">{label || "Loading"}</span>
    </span>
  );
}

/** Centred block spinner for whole-panel loading states. */
export function LoadingPanel({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex items-center justify-center py-16">
      <Spinner size="lg" label={label} />
    </div>
  );
}
